module.exports = __webpack_public_path__ + "img/yellow.e73bacda.jpg";